import { CssBaseline, ThemeProvider } from '@mui/material';
import { useGetOrganizations } from 'apis/agency/organizations/hook';
import { useEffect, useState } from 'react';
import { CacheKeys } from 'utils/cacheKeys';
import { getCookie, setCookie } from 'utils/helperFunctions';
import { getTheme } from 'utils/theme/theme';

export const DynamicThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const storedThemeColor = getCookie(CacheKeys.themeColor);
  const [currentTheme, setCurrentTheme] = useState<string>(storedThemeColor || '#4B22A8');
  const { data: organizations } = useGetOrganizations();

  useEffect(() => {
    if (!storedThemeColor && organizations?.configuration?.brand_color) {
      const brandColor = organizations.configuration.brand_color;
      setCurrentTheme(brandColor);
      setCookie(CacheKeys.themeColor, brandColor); // save in cookies
    }
  }, [storedThemeColor, organizations]);

  const theme = getTheme(currentTheme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};
